import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
interface PageTransitionProps {
  children: React.ReactNode;
}
const PageTransition: React.FC<PageTransitionProps> = ({
  children
}) => {
  const location = useLocation();
  // Handle hash navigation when page loads or changes
  useEffect(() => {
    if (location.hash) {
      // Delay to ensure content is loaded and animation is complete
      setTimeout(() => {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 500);
    } else {
      // If no hash, scroll to top of page
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.3
  }} data-id="element-633">
      {children}
    </motion.div>;
};
export default PageTransition;